import { Module } from '@nestjs/common';
import { RmIndentQtyLimitService } from './rm-indent-qty-limit.service';
import { RmIndentQtyLimitController } from './rm-indent-qty-limit.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RmIndentQtyLimit } from './rm-indent-qty-limit.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RmIndentQtyLimitAdapter } from './dto/rm-indent-qty-limit.adapter';
@Module({
  imports:[
    TypeOrmModule.forFeature([RmIndentQtyLimit])
  ],
  providers: [RmIndentQtyLimitService,ApplicationExceptionHandler,RmIndentQtyLimitAdapter],
  controllers: [RmIndentQtyLimitController]
})
export class RmIndentQtyLimitModule {}
